// V kombinaci se styly je funkcionalita dle návrhu pouze pro mobilní zobrazení

export const footerLinkList = (lists: NodeListOf<HTMLElement>): void => {
    // Pro každý seznam
    lists.forEach((list: HTMLElement) => {
        const items: NodeListOf<HTMLElement> | null = list.querySelectorAll('[data-footer-link-list-item]');

        // Pro každý prvek
        items.forEach((item: HTMLElement) => {
            // Přidat event listener na kliknutí
            if (item) {
                item.addEventListener('click', (e: Event) => {
                    const target = e.target as HTMLElement;
                    const item = target.closest('.footer-link-list__item');

                    if (item) {
                        // Změnit modifikátor 'otevřenosti'
                        item.classList.toggle('footer-link-list__item--collapsed');

                        // Otočit ikonu
                        const icon = item.querySelector('[data-footer-link-list-title-icon]');
                        if (icon) {
                            icon.classList.toggle('footer-link-list__title-icon--rotate');
                        }
                    }

                });
            }

        })

    })

};